<script setup lang="ts">
import FormFieldCell from './FormFieldCell.vue'
import type { WidgetAttributes } from '../utils/claim-editor'
import { useClaimFormContext } from '../composables/fields'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  name: string
  attributes: WidgetAttributes
  dataType: 'number' | 'string'
}>()

const MAX_VALUE = 9_999_999.99

const { state } = useClaimFormContext()

const onUpdate = (value: number | null | undefined) => {
  state[props.name] =
    value == null
      ? undefined
      : props.dataType === 'number'
        ? value
        : value.toFixed(2)
}
</script>

<template>
  <FormFieldCell :name="props.name">
    <UInputNumber
      v-bind="attributes"
      :name="props.name"
      class="w-full"
      :decrement="false"
      :format-options="{ style: 'currency', currency: 'USD' }"
      :increment="false"
      :max="MAX_VALUE"
      :min="0"
      :model-value="
        state[props.name] == null ? undefined : Number(state[props.name])
      "
      :step="0.01"
      :ui="{ base: 'rounded-none' }"
      size="xs"
      variant="none"
      @update:model-value="onUpdate"
    />
  </FormFieldCell>
</template>
